var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHxCheckCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.833496C4.93743 0.833496 0.833374 4.93755 0.833374 10.0002C0.833374 15.0628 4.93743 19.1668 10 19.1668C15.0626 19.1668 19.1667 15.0628 19.1667 10.0002C19.1667 4.93755 15.0626 0.833496 10 0.833496ZM14.3393 8.08942C14.6647 7.76398 14.6647 7.23634 14.3393 6.91091C14.0139 6.58547 13.4862 6.58547 13.1608 6.91091L8.75004 11.3217L6.8393 9.41091C6.51386 9.08547 5.98622 9.08547 5.66078 9.41091C5.33535 9.73634 5.33535 10.264 5.66078 10.5894L8.16078 13.0894C8.48622 13.4149 9.01386 13.4149 9.3393 13.0894L14.3393 8.08942Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxCheckCircleFilled);
export default __webpack_public_path__ + "static/media/hx_check-circle-filled.fc1a882601f655a83ba610b3811e2f34.svg";
export { ForwardRef as ReactComponent };